import { render } from "./OptionEditorFull.vue?vue&type=template&id=320c5a32"
import script from "./OptionEditorFull.vue?vue&type=script&lang=js"
export * from "./OptionEditorFull.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__